export const SET_TOKEN_REFRESH = 'SET_TOKEN_REFRESH';
export const RICHIEDI_TOKEN_ACTION = 'RICHIEDI_TOKEN_ACTION';
export const VERIFICA_RUOLI_ACTION = 'VERIFICA_RUOLI_ACTION';

export const RECUPERA_GENERALITA = 'RECUPERA_GENERALITA';
export const GET_TOKEN = 'GET_TOKEN';
export const GET_APPCODE_AUTHCODE = 'GET_APPCODE_AUTHCODE';

export const RECUPERA_PROFILI_SUCCESS = 'RECUPERA_PROFILI_SUCCESS';
export const RECUPERA_PROFILI_FAIL = 'RECUPERA_PROFILI_FAIL';

export const SALVA_RUOLO_SCELTO = 'SALVA_RUOLO_SCELTO';

export const INIT_AUTH = 'INIT_AUTH';
export const CLEAR_ERROR = 'CLEAR_ERROR';

export const REQUEST_REFRESH_TOKEN_START = 'REQUEST_REFRESH_TOKEN_START';
export const REQUEST_REFRESH_TOKEN_FAIL = 'REQUEST_REFRESH_TOKEN_FAIL';

